import { render, staticRenderFns } from "./EmbossBox.vue?vue&type=template&id=be24a914"
import script from "./EmbossBox.vue?vue&type=script&lang=js"
export * from "./EmbossBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports